import { useState, useEffect } from "react";
import { GET_BLOGS } from '../api/constants'

export const useBlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(GET_BLOGS);
        const data = await response.json();

        if (data.status) {
          setBlogs(data.data || []);
        } else {
          setBlogs([]);
          setError(data.message || "Failed to fetch blogs");
        }
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError("Failed to fetch blogs");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return { blogs, loading, error };
};
